<template>
  <div class="right-center">
    <a-row v-for="(item, index) in relaInfotabledata" :key="index">
      <a-col :span="3">
        <div style="width: 64px; height: 64px">
          <img
            v-if="item.avatar"
            :src="item.avatar"
            alt=""
            :title="item.relatedPersonnelName"
            width="100%"
            height="100%"
          />
          <img
            v-else
            src="@/assets/images/defaultHeader.svg"
            alt=""
            :title="item.relatedPersonnelName"
            width="100%"
            height="100%"
          />
        </div>
      </a-col>
      <a-col :span="15">
        <p class="department">
          {{ item.relatedDeptName ? item.relatedDeptName + ' · ' : ' · ' }}{{ item.relatedPersonnelName }}
        </p>
        <p class="editdept">
          {{ item.relatedPersonnelType | filterDict(relatedPersonneTypeOpts) }}
          <span style="font-size: 12px; line-height: 24px"> {{ item.createTime }} </span>
        </p>
      </a-col>
      <div style="position: absolute; right: 0; top: 36px">
        <div style="padding-left: 17px">
          <a-button
            @click="Editor(item, '编辑人员')"
            type="primary"
            shape="circle"
            icon="edit"
            v-show="editbtnshow"
            style="color: #fff; background: var(--ThemeColor); border-color: var(--ThemeColor)"
          >
          </a-button>
        </div>
      </div>
    </a-row>
    <div style="margin-top: 15px"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {
             relatedPersonneTypeOpts: [] // 相关人员类型 字典表类型：related_personne_type
    }
  },
  methods: {
    Editor (item, data) {
        this.$emit('Editor', item, data)
    }
},
mounted () {
        // 相关人员类型 字典表类型：related_personne_type
    this.getDicts('related_personne_type').then((response) => {
      this.relatedPersonneTypeOpts = response.data
    })
},
props: {
    editbtnshow: {
        type: Boolean,
        default: false
    },
    relaInfotabledata: {
        type: Array,
        default: () => []
    }
},
  filters: {
   filterDict (val, opts) {
      if (!val) return
      for (const d of opts) {
        if (d.dictValue == val) {
          return d.dictLabel
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
    .bot-detail-right {
            width: 49.5%;
            // padding: 30px 0 0 2px;
            border-radius: 3px;
            -webkit-border-radius: 3px;
            border: 2px solid #f2f6fc;
            // margin-right: 41px;

            .right-center {
              p{
                margin-bottom:0;
              }
              .department{
                line-height:32px;
              }
              .editdept{
                line-height:32px;
              }
            img {
                width: 64px;
                height: 64px;
                border-radius: 64px;
                -webkit-border-radius: 64px;
                // margin-top: 20px;
                margin-top: 0px;
            }
            width: 94%;
            margin: 0 auto;
            /deep/ .ant-row {
                // margin-bottom: 30px;
                border-bottom: 1px solid #f2f6fc;
                padding-bottom: 15px;
                padding-top: 15px;
            }

            /deep/.ant-col-4 {
                & > img {
                width: 90px;
                height: 90px;
                border-radius: 100px;
                }
            }

            /deep/.ant-col-20 {
                & > p {
                &:nth-of-type(1) {
                    font-size: 14px;
                    color: black;
                    font-weight: bold;
                    margin-top: 14px;
                }

                &:nth-of-type(2) {
                    font-size: 14px;
                    color: black;

                    & > span {
                    font-size: 14px;
                    font-weight: normal;
                    color: #c2c1bf;
                    margin-left: 20px;
                    }
                }
                }
            }
            }
    }
</style>
